import type { TemplateRef } from '@angular/core';
import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StickyFooterService {
  private template: BehaviorSubject<TemplateRef<any> | null> = new BehaviorSubject(null);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public template$: Observable<TemplateRef<any> | null> = this.template.asObservable();

  public setStickyTemplate(template: TemplateRef<any>, until?: Observable<any>): void {
    this.template.next(template);

    if (until) {
      until.pipe(take(1)).subscribe(() => this.clearTemplate());
    }
  }

  public clearTemplate(): void {
    this.template.next(null);
  }
}
